// Importing action types and initial state
import CryptoJS from "crypto-js";
import * as types from "../Actions/ActionTypes";
import initialState from "./initailState";

// Reducer function to manage the app state
const merchantInformation = (
  state = initialState.merchantInformation,
  action
) => {
  const encryptionKey = process.env.REACT_APP_ENCRYPTION_ENVIRONMENT;
  const secretKey = process.env.REACT_APP_ENCRIPTION_KEY;
  switch (action.type) {
    case types.UPLOAD_DOCUMNET_FINAL_OFFER_CALL:
      return { ...state, loading: true };
    case types.UPLOAD_DOCUMNET_FINAL_OFFER_SUCCESS:
      return { ...state, uploadDocument: action.data, loading: false };
    case types.UPLOAD_DOCUMNET_FINAL_OFFER_ERROR:
    case types.EMPTY_REDUX_STATE:
      return {
        ...state,
        routingNumberData: false,
        sendMoneyData: false,
        merchantListData: false,
        // managerListData: false,
      };
    case types.EMPTY_MERCHANT_RTN_REDUX_STATE:
      return {
        ...state,
        routingNumberData: false,
      };
    case types.EMPTY_GROUP_CODE_LIST_REDUX_STATE:
      return {
        ...state,
        merchantGroupCodeListPortfolios: false,
      };
    case types.EMPTY_MERCHANT_ACC_REDUX_STATE:
      return {
        ...state,
        accountNumberData: false,
      };
    case types.EMPTY_EMAIL_LIST_REDUX_STATE:
      return {
        ...state,
        emailData: false,
        emailListData: false,
      };
    case types.SEND_MONEY_CALL:
      return { ...state, loading: true };
    case types.SEND_MONEY_SUCCESS:
      return { ...state, sendMoneyData: action.data, loading: false };
    case types.SEND_MONEY_ERROR:
      return { ...state, error: false, loading: false };
    case types.SHOW_EMAIL_USER_DETAILS_CALL:
      return { ...state, loading: true };
    case types.SHOW_EMAIL_USER_DETAILS_SUCCESS:
      return {
        ...state,
        showUserDetailsViaMail: action.data,
        loading: false,
      };
    case types.SHOW_EMAIL_USER_DETAILS_ERROR:
      return { ...state, error: false, loading: false };

    case types.PAYMENT_LINK_VERIFY_CALL:
      return { ...state, paymentVerifyData: action.data, loading: true };
    case types.PAYMENT_LINK_VERIFY_CALL_SUCCESS:
      return { ...state, paymentVerifyData: action.data, loading: false };
    case types.PAYMENT_LINK_VERIFY_CALL_ERROR:
      return { ...state, error: false, loading: false };

    case types.MAKE_PAYMENT_SUCCESS:
      return { ...state, paymentCompleteData: action.data, loading: false };
    case types.MAKE_PAYMENT_ERROR:
      return { ...state, error: false, loading: false };
    case types.SIGN_UP_CALL:
      return { ...state, signUpData: action.data, loading: true };
    case types.SIGN_UP_SUCCESS:
      return { ...state, signUpData: action.data, loading: false };
    case types.SIGN_UP_ERROR:
      return { ...state, error: false, loading: false };
    case types.SUBMIT_API_CALL:
      return { ...state, submitApiData: action.data, loading: true };
    case types.SUBMIT_API_SUCCESS:
      return { ...state, submitApiData: action.data, loading: false };
    case types.SUBMIT_API_ERROR:
      return { ...state, error: false, loading: false };
    case types.USER_FORGET_PASSWORD_CALL:
      return { ...state, loading: true };
    case types.USER_FORGET_PASSWORD_SUCCESS:
      return { ...state, forgetPassword: action.data, loading: false };
    case types.USER_FORGET_PASSWORD_ERROR:
      return { ...state, error: false, loading: false };
    case types.CHECK_RESET_PASSWORD_AUTH_CHECK_CALL:
      return { ...state, loading: true };
    case types.CHECK_RESET_PASSWORD_AUTH_CHECK_SUCCESS:
      return { ...state, authTokenCheck: action.data, loading: false };
    case types.CHECK_RESET_PASSWORD_AUTH_CHECK_ERROR:
      return { ...state, error: false, loading: false };
    case types.CHANGE_USER_PASSWORD_CALL:
      return { ...state, loading: true };
    case types.CHANGE_USER_PASSWORD_SUCCESS:
      return { ...state, changePassword: action.data, loading: false };
    case types.CHANGE_USER_PASSWORD_ERROR:
      return { ...state, error: false, loading: false };
    case types.USER_DOCUMENT_LIST_CALL:
      return { ...state, loading: true };
    case types.USER_DOCUMENT_LIST_SUCCESS:
      return { ...state, USERDocumentList: action.data, loading: false };
    case types.USER_DOCUMENT_LIST_ERROR:
      return { ...state, error: false, loading: false };
    case types.ADD_PROPOSAL_DETAILS_CALL:
      return { ...state, loading: true, addProposalData: false };
    case types.ADD_PROPOSAL_DETAILS_SUCCESS:
      return {
        ...state,
        addProposalData: action.data,
        loading: false,
        data: false,
      };
    case types.ADD_PROPOSAL_DETAILS_ERROR:
      return { ...state, error: false, loading: false };
    case types.ROUTING_NUMBER_CALL:
      return { ...state, loading: true };
    case types.ROUTING_NUMBER_SUCCESS:
      const bytes = CryptoJS.AES.decrypt(action.data.data, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      const parsedData = encryptionKey === "NO" ? action.data.data : JSON.parse(decryptedData);
      return {
        ...state,
        routingNumberData: parsedData,
        loading: false,
      };
    case types.ROUTING_NUMBER_ERROR: {
      let parsedData;

      if (encryptionKey === "NO") {
        parsedData = action.data.data;
      } else if (typeof action.data.data === "string") {
        const bytes = CryptoJS.AES.decrypt(action.data.data, secretKey);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        parsedData = JSON.parse(decryptedData);
      } else {
        // Backend already returned a plain object
        parsedData = action.data.data;
      }

      return {
        ...state,
        routingNumberData: parsedData,
        error: false,
        loading: false,
      };
    }
    case types.ACCOUNT_NUMBER_CALL:
      return { ...state, loading: true };
    case types.ACCOUNT_NUMBER_SUCCESS:
      return {
        ...state,
        accountNumberData: action.data,
        loading: false,
      };
    case types.ACCOUNT_NUMBER_ERROR:
      return {
        ...state,
        accountNumberData: action.data || false,
        error: false,
        loading: false,
      };
    case types.GET_MERCHANT_GROUP_CODE_LIST:
      return { ...state, loading: false };
    case types.GET_MERCHANT_GROUP_CODE_SUCCESS: {
      const responseData = action.data?.data;
      const decryptedData = encryptionKey === "NO"
        ? responseData
        : (() => {
          try {
            const bytes1 = CryptoJS.AES.decrypt(responseData, secretKey);
            const decryptedText = bytes1.toString(CryptoJS.enc.Utf8);
            return JSON.parse(decryptedText);
          } catch (error) {
            return responseData;
          }
        })();
      return {
        ...state,
        marchantGroupCodeList: {
          ...action.data,
          data: decryptedData,
        },
        loading: false,
      };
    }
    case types.GET_MERCHANT_GROUP_CODE_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_MERCHANT_GROUP_CODE_LIST_PORTFOLIOS:
      return { ...state, loading: false };
    case types.GET_MERCHANT_GROUP_CODE_LIST_PORTFOLIOS_SUCCESS: {
      const responseData = action.data?.data;
      const decryptedData = encryptionKey === "NO"
        ? responseData
        : (() => {
          try {
            const bytes1 = CryptoJS.AES.decrypt(responseData, secretKey);
            const decryptedText = bytes1.toString(CryptoJS.enc.Utf8);
            return JSON.parse(decryptedText);
          } catch (error) {
            return responseData;
          }
        })();
      return {
        ...state,
        merchantGroupCodeListPortfolios: {
          ...action.data,
          data: decryptedData,
        },
        loading: false,
      };
    }
    case types.GET_MERCHANT_GROUP_CODE_LIST_PORTFOLIOS_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_RTP_ACH_LIST:
      return { ...state, loading: true };
    case types.GET_RTP_ACH_LIST_SUCCESS:
      return {
        ...state,
        achRtpList: action.data,
        loading: false,
      };
    case types.GET_RTP_ACH_LIST_ERROR:
      return { ...state, error: false, loading: false };
    case types.MANAGER_PERSONAL_INFO_LIST:
      return { ...state, loading: true };
    case types.MANAGER_PERSONAL_INFO_LIST_SUCCESS:
      const bytesdeDecrypt = CryptoJS.AES.decrypt(action.data.data, secretKey);
      const decryptedDataDecrypt = bytesdeDecrypt.toString(CryptoJS.enc.Utf8);
      const parsedDataDecrypt = encryptionKey === "NO"
        ? action.data.data
        : JSON.parse(decryptedDataDecrypt);
      return {
        ...state,
        managerPersonalInfo: {
          ...action.data,
          data: parsedDataDecrypt,
        },
        loading: false,
      };
    case types.MANAGER_PERSONAL_INFO_LIST_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_MERCHANT_LIST:
      return { ...state, loading: true };
    case types.GET_MERCHANT_LIST_SUCCESS:
      const bytes1 = CryptoJS.AES.decrypt(action.data.data, secretKey);
      const decryptedData1 = bytes1.toString(CryptoJS.enc.Utf8);
      const parsedData1 = encryptionKey === "NO" ? action.data.data : JSON.parse(decryptedData1);
      return {
        ...state,
        merchantListData: {
          ...action.data,
          data: parsedData1,
        },
        loading: false,
      };
    case types.GET_MERCHANT_LIST_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_MERCHANT_LIST_NAMES:
      return { ...state, loading: true };
    case types.GET_MERCHANT_LIST_NAMES_SUCCESS:
      const bytes2 = CryptoJS.AES.decrypt(action.data.data, secretKey);
      const decryptedData2 = bytes2.toString(CryptoJS.enc.Utf8);
      const parsedData2 = encryptionKey === "NO" ? action.data.data : JSON.parse(decryptedData2);
      return {
        ...state,
        merchantListNames: {
          ...action.data,
          data: parsedData2,
        },
        loading: false,
      };
    case types.GET_MERCHANT_LIST_NAMES_ERROR:
      return { ...state, error: false, loading: false };
    case types.SET_FORM_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case types.CLEAR_FORM_DATA:
      return {
        ...state,
        formData: {
          searchBusinessName: "",
          searchDbaName: "",
          searchStatus: null,
          searchStatusValue: "",
          searchManagerName: "",
        },
      };
    case types.GET_MANAGER_LIST:
      return { ...state, loading: true };
    case types.GET_MANAGER_LIST_SUCCESS:
      const bytes4 = CryptoJS.AES.decrypt(action.data.data, secretKey);
      const decryptedData4 = bytes4.toString(CryptoJS.enc.Utf8);
      const parsedData4 = encryptionKey === "NO" ? action.data.data : JSON.parse(decryptedData4);
      return {
        ...state,
        managerListData: {
          ...action.data,
          data: parsedData4,
        },
        loading: false,
      };
    case types.GET_MANAGER_LIST_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_MANAGER_LIST_BY_ID:
      return { ...state, loading: true };
    case types.GET_MANAGER_LIST_SUCCESS_BY_ID:
      const bytes6 = CryptoJS.AES.decrypt(action.data.data, secretKey);
      const decryptedData6 = bytes6.toString(CryptoJS.enc.Utf8);
      const parsedData6 = encryptionKey === "NO" ? action.data.data : JSON.parse(decryptedData6);
      return {
        ...state,
        managerListDataById: {
          ...action.data,
          data: parsedData6,
        },
        loading: false,
      };
    case types.GET_MANAGER_LIST_ERROR_BY_ID:
      return { ...state, error: false, loading: false };
    case types.GET_MANAGER_LIST_NAMES:
      return { ...state, loading: true };
    case types.GET_MANAGER_LIST_NAMES_SUCCESS:
      const bytes5 = CryptoJS.AES.decrypt(action.data.data, secretKey);
      const decryptedData5 = bytes5.toString(CryptoJS.enc.Utf8);
      const parsedData5 = encryptionKey === "NO" ? action.data.data : JSON.parse(decryptedData5);
      return {
        ...state,
        managerListNames: {
          ...action.data,
          data: parsedData5,
        },
        loading: false,
      };
    case types.GET_MANAGER_LIST_NAMES_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_MANAGER_ACTIONS_LIST:
      return { ...state, loading: true };
    case types.GET_MANAGER_ACTIONS_LIST_SUCCESS:
      return {
        ...state,
        managerActionsData: action.data,
        loading: false,
      };
    case types.GET_MANAGER_ACTIONS_LIST_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_MANAGER_ACTIONS:
      return { ...state, loading: true };
    case types.GET_MANAGER_ACTIONS_SUCCESS:
      return {
        ...state,
        managerActionsLink: action.data,
        loading: false,
      };
    case types.GET_MANAGER_ACTIONS_ERROR:
      return { ...state, error: false, loading: false };
    case types.SET_FORM_DATA_MANAGER:
      return {
        ...state,
        ...action.payload,
      };
    case types.CLEAR_FORM_DATA_MANAGER:
      return {
        ...state,
        formDataManager: {
          searchBusinessName: "",
          searchManagerUID: "",
          searchEmail: "",
          searchStatus: null,
          searchStatusValue: "",
          searchManagerName: "",
          searchManagerId: "",
          searchPlatform: "",
          searchManagerType: "",
        },
      };
    case types.GET_TRANSACTION_LIST:
      return { ...state, loading: true };
    case types.GET_TRANSACTION_LIST_SUCCESS:
      const bytes3 = CryptoJS.AES.decrypt(action.data.data, secretKey);
      const decryptedData3 = bytes3.toString(CryptoJS.enc.Utf8);
      const parsedData3 = encryptionKey === "NO" ? action.data.data : JSON.parse(decryptedData3);
      return {
        ...state,
        transactionListData: {
          ...action.data,
          data: parsedData3,
        },
        loading: false,
      };
    case types.GET_TRANSACTION_LIST_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_TRANSACTION_HISTORY:
      return { ...state, loading: true };
    case types.GET_TRANSACTION_HISTORY_SUCCESS:
      return {
        ...state,
        transactionHistoryData: action.data,
        loading: false,
      };
    case types.GET_TRANSACTION_HISTORY_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_API_LOGS:
      return { ...state, loading: true };
    case types.GET_API_LOGS_SUCCESS:
      const bytesData4 = CryptoJS.AES.decrypt(action.data.data, secretKey);
      const decryptedBytes4 = bytesData4.toString(CryptoJS.enc.Utf8);
      const parsedBytesData = encryptionKey === "NO" ? action.data.data : JSON.parse(decryptedBytes4);
      return {
        ...state,
        apiLogsData: {
          ...action.data,
          data: parsedBytesData,
        },
        loading: false,
      };
    case types.GET_API_LOGS_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_API_LOGS_FETCH_LOGS:
      return { ...state, loading: true };
    case types.GET_API_LOGS_FETCH_LOGS_SUCCESS:
      const bytesData5 = CryptoJS.AES.decrypt(action.data.data, secretKey);
      const decryptedBytes5 = bytesData5.toString(CryptoJS.enc.Utf8);
      const parsedBytesDataLogs =
        encryptionKey === "NO" ? action.data.data : JSON.parse(decryptedBytes5);
      return {
        ...state,
        apiLogsDataFetchLogs: {
          ...action.data,
          data: parsedBytesDataLogs,
        },
        loading: false,
      };
    case types.GET_API_LOGS_FETCH_LOGS_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_API_LOGS_BY_ID_FETCH_LOGS:
      return { ...state, loading: true };
    case types.GET_API_LOGS_BY_ID_FETCH_LOGS_SUCCESS:
      const bytesData6 = CryptoJS.AES.decrypt(action.data.data, secretKey);
      const decryptedBytes6 = bytesData6.toString(CryptoJS.enc.Utf8);
      const parsedByLogsDataLogs =
        encryptionKey === "NO" ? action.data.data : JSON.parse(decryptedBytes6);
      return {
        ...state,
        apiLogsByIdDataFetchLogs: {
          ...action.data.data,
          data: parsedByLogsDataLogs,
        },
        loading: false,
      };
    case types.GET_API_LOGS_BY_ID_FETCH_LOGS_ERROR:
      return { ...state, error: false, loading: false };
    case types.SET_FORM_DATA_API_LOGS:
      return {
        ...state,
        ...action.payload,
      };
    case types.CLEAR_FORM_DATA_API_LOGS:
      return {
        ...state,
        searchRequestedFor: "",
        searchApiType: "",
        searchApiTypeValue: "",
        searchModule: "",
        searchModuleValue: "",
        searchRequestDate: "",
        searchResponseDate: "",
        searchStatus: "",
        searchStatusValue: "",
        searchStartDate: "",
        searchEndDate: "",
        dateRange: false,
        formData: {
          searchRequestedFor: "",
          searchApiType: "",
          searchApiTypeValue: "",
          searchModule: "",
          searchModuleValue: "",
          searchRequestDate: "",
          searchResponseDate: "",
          searchStatus: "",
          searchStatusValue: "",
          searchStartDate: "",
          searchEndDate: "",
          dateRange: false,
        },
      };
    case types.GET_ERROR_CODE:
      return { ...state, loading: true };
    case types.GET_ERROR_CODE_SUCCESS:
      return {
        ...state,
        errorCodeData: action.data,
        loading: false,
      };
    case types.GET_ERROR_CODE_ERROR:
      return { ...state, error: false, loading: false };
    case types.SET_FORM_DATA_ERROR_CODES:
      return {
        ...state,
        ...action.payload,
      };
    case types.CLEAR_FORM_DATA_ERROR_CODES:
      return {
        ...state,
        formDataErrorCodes: {
          searchErrorCode: "",
          searchType: "",
          searchDescription: "",
          searchUpdatedOn: "",
        },
      };
    case types.SETUP_MONTHLY_FROM_OFFER:
      return { ...state, setUpMonthltFromOffer: action.data };
    case types.GENRATE_OFFER_LOADING_FALSE:
      return { ...state, genrateOfferLoading: action.data };
    case types.SET_DEFAULT_VALUE_OFFER:
      return { ...state, defaultValueOffer: action.data };
    case types.SET_BACK_TO_SEARCH_FROM_OFFER:
      return { ...state, activeMobileList: false };
    case types.EMPTY_OFFER_SELECT_USER:
      return {
        ...state,
        activeMobileList: false,
        completedPlanUserList: false,
        USERDocumentList: false,
      };
    case types.BEFORE_PAYMENT_SEND_OTP_CALL:
      return { ...state, loading: true };
    case types.BEFORE_PAYMENT_SEND_OTP_SUCCESS:
      return { ...state, sentOTPData: action.data, loading: false };
    case types.BEFORE_PAYMENT_SEND_OTP_ERROR:
      return { ...state, error: false, loading: false };
    case types.SET_USER_ID_FORGET_PASSWORD:
      return { ...state, userIdForgetPassword: action.data };
    case types.PAYMENT_CHECKOUT_CALL:
      return { ...state, loading: true };
    case types.PAYMENT_CHECKOUT_SUCCESS:
      return { ...state, paymentCheckoutData: action.data, loading: false };
    case types.PAYMENT_CHECKOUT_ERROR:
      return { ...state, error: false, loading: false };
    case types.SET_FORM_DATA_TRANSACTION_HISTORY:
      return {
        ...state,
        ...action.payload,
      };
    case types.CLEAR_FORM_DATA_TRANSACTION_HISTORY:
      return {
        ...state,
        searchDataTransactionHistory: {
          searchTxnID: "",
          searchStartAmount: "",
          searchEndAmount: "",
          searchStartDate: "",
          searchEndDate: "",
          dateRange: false,
          amountRange: false,
        },
      };
    case "SET_TRANSACTION_LIST_PAGE":
      return {
        ...state,
        transactionListPagination: {
          ...state.transactionListPagination,
          currentPage: action.payload,
        },
      };
    case "SET_TRANSACTION_LIST_ROWS_PER_PAGE":
      return {
        ...state,
        transactionListPagination: {
          ...state.transactionListPagination,
          rowsPerPage: action.payload,
        },
      };
    case types.GET_EMAIL_LIST:
      return { ...state, loading: false };
    case types.GET_EMAIL_LIST_SUCCESS:
      return {
        ...state,
        emailListData: action.data,
        loading: false,
      };
    case types.GET_EMAIL_LIST_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_EMAIL_DATA:
      return { ...state, loading: true };
    case types.GET_EMAIL_DATA_SUCCESS:
      return {
        ...state,
        emailData: action.data,
        loading: false,
      };
    case types.GET_EMAIL_DATA_ERROR:
      return { ...state, error: false, loading: false };
    case types.GET_EMAIL_DATA1:
      return { ...state };
    case types.GET_EMAIL_DATA1_SUCCESS:
      return {
        ...state,
        emailData1: action.data,
      };
    case types.GET_EMAIL_DATA1_ERROR:
      return { ...state, error: false, loading: false };
    case "SET_MERCHANT_LIST_PAGE":
      return {
        ...state,
        merchantListPagination: {
          ...state.merchantListPagination,
          currentPage: action.payload,
        },
      };
    case "SET_MERCHANT_LIST_ROWS_PER_PAGE":
      return {
        ...state,
        merchantListPagination: {
          ...state.merchantListPagination,
          rowsPerPage: action.payload,
        },
      };
    default:
      return state;
  }
};

export default merchantInformation;
